import { MockServiceStore } from "./MockServiceStore";

/**
 * StructureCast - Project
 */
export interface StructureCastProject {
  id: string;
  projectCode: string;
  projectName: string;
  clientId: string;
  location: string;
  state: string;
  stationReference: string;
  mixDesign: string;
  projectManager: string;
  startDate: string;
  estimatedEndDate: string;
  status: "active" | "on_hold" | "completed" | "cancelled";
  createdAt: string;
  updatedAt: string;
}

export const mockStructureCastProjects: StructureCastProject[] = [
  {
    id: "sc-proj-1",
    projectCode: "25-1585",
    projectName: "Heritage Ranch WRRF — Sanitary Sewer",
    clientId: "sc-client-1",
    location: "Heritage Ranch, Nacimiento Lake Dr, Paso Robles, CA",
    state: "CA",
    stationReference: "Heritage Ranch WRRF — 48\" Sanitary Sewer Manhole Network",
    mixDesign: "5,000 PSI",
    projectManager: "MSCP Estimating (Office)",
    startDate: "2026-01-19T00:00:00.000Z",
    estimatedEndDate: "2026-04-10T00:00:00.000Z",
    status: "active",
    createdAt: "2025-05-29T00:00:00.000Z",
    updatedAt: "2026-01-19T00:00:00.000Z",
  },
];

export const createMockStructureCastProjectStore = () =>
  new MockServiceStore<StructureCastProject>({
    mockData: mockStructureCastProjects,
    idField: "id",
    simulateDelay: 200,
    persistKey: "preferred-structurecast-projects",
  });

export default mockStructureCastProjects;
